export enum NavMenuOptions {
  OVERVIEW = 'Deloitte Cloud Accelerator... Accelerating Multi Cloud Foundation',
  OPERATIONS = 'Operations - Jobs Ruleset',
  ASSET_AUTHORISATION = 'Asset Authorization',
  WEB_ANALYTICS = 'Web Analytics',
  DOCUMENTATION = 'Documentation',
  QUICK_LINKS = 'Quick Links',
  KEY_CONTACTS = 'Key Contacts',
  FEEDBACK = 'Feedback',
  FEEDBACK_RESPONSE = 'Admin - Feedback',
  USER_MANAGEMENT = 'User Management',
  ACCOUNT_MANAGEMENT = 'Account & Project Management',
  ASSESSMENT = 'Assessment',
  CBOSUMMARY = 'CBO Summary',
  CONFIGUREJOURNEY = 'Configure Journey',
}

export const pageSizeOptions = ['5', '10', '15', '20'];

export const devEnvironments = ['tangradev.deloitte.com', 'dev.dca.deloitte.com', 'dca-frontend-201514097239.us-east1.run.app'];
export const localhostEnvironments = ['localhost'];
export const demoEnvironments = ['demo.dca.deloitte.com'];
export const termsandConditionsUrl =
  'https://www2.deloitte.com/us/en/footerlinks1/privacy.html?icid=bottom_privacy';
export enum Environment {
  DEV = 'dev',
  PROD = 'prod',
  LOCALHOST = 'localhost',
  DEMO = 'demo',
}
export enum PipelineType {
  ADD = 'add',
  EDIT = 'edit',
}

export enum CloudServiceProvider {
  AWS = 'aws',
  GCP = 'gcp',
  AZURE = 'azure',
  ORACLE = 'oracle',
  OPENSHIFT_AZURE = 'openshift_azure',
  OPENSHIFT_AWS = 'openshift_aws',
  VMWARE = 'vmware',
  MULTICLOUD = 'multicloud',
}
export const CloudServiceProviderTemplate: {
  [key in CloudServiceProvider]: Array<{ label: string; value: string }>;
} = {
  [CloudServiceProvider.AWS]: [
    {
      label: 'Terraform',
      value: 'terraform',
    },
    {
      label: 'CloudFormation',
      value: 'cloudformation',
    },
  ],
  [CloudServiceProvider.GCP]: [
    {
      label: 'Terraform',
      value: 'terraform',
    },
    {
      label: 'Deployment Manager',
      value: 'deploymentmanager',
    },
  ],
  [CloudServiceProvider.AZURE]: [
    {
      label: 'Terraform',
      value: 'terraform',
    },
    {
      label: 'Azure Resource Manager',
      value: 'arm',
    },
    {
      label: 'Bicep Template',
      value: 'bicep',
    },
  ],
  [CloudServiceProvider.ORACLE]: [
    {
      label: 'Terraform',
      value: 'terraform',
    },
    {
      label: 'Resource Manager',
      value: 'resourcemanager',
    },
  ],
  [CloudServiceProvider.VMWARE]: [
    {
      label: 'vmWare Template 1',
      value: 'vmWareTemplate1',
    },
    {
      label: 'vmWare Template 2',
      value: 'vmWareTemplate2',
    },
  ],
  [CloudServiceProvider.OPENSHIFT_AWS]: [],
  [CloudServiceProvider.OPENSHIFT_AZURE]: [],
  [CloudServiceProvider.MULTICLOUD]: [],
};

export const DUMMY_ACCESS_TOKEN = '1';

export const fileExtensions = {
  png: '.png',
  yaml: '.yaml',
  xlsx: '.xlsx',
};

export const mobileScreenConstant = 720;

export enum StatusType {
  active = 'Active',
  inactive = 'Inactive',
  premium = 'Premium',
  scpPolicy = 'SCP Policy',
}
export const cmsPortalUrls = 'https://deloitteauthqa.opencloudportal.com/';
export const cb360PortalUrl = 'https://qaportal-cb360.us.deloitte.com';
export const cboLoginRedirectionLink = 'https://corebusinessone.dca.deloitte.com/cbo-login';

export const logoutModalText =
  'Due to user inactivity your session is about to expire. You want to stay logged in?';
export const timeOutTime = 1000 * 60 * 25; // 25 mins
export enum ProtalConstant {
  DCA = 'DCA',
  DMAP = 'DMAP',
}

export const GithubRepositories: Array<{ label: string; link: string }> = [
  {
    label: 'Tangra-UI',
    link: 'https://github.com/Deloitte-US/tangra-ui',
  },
  {
    label: 'DCA-DMAP',
    link: 'https://github.com/Deloitte-US/DCA-DMAP',
  },
  {
    label: 'Tangra-BE',
    link: 'https://github.com/Deloitte-US/Tangra-BE',
  },
  {
    label: 'Tangra-DCA',
    link: 'https://github.com/Deloitte-US/Tangra-DCA',
  },
  {
    label: 'DCA-Azure',
    link: 'https://github.com/Deloitte-US/DCA-Azure',
  },
  {
    label: 'DCA-AWS',
    link: 'https://github.com/Deloitte-US/DCA-AWS',
  },
  {
    label: 'DCA-GCP',
    link: 'https://github.com/Deloitte-US/DCA-GCP',
  },
  {
    label: 'DCA-ECS',
    link: 'https://github.com/Deloitte-US/dca-ecs-failover-recovery',
  },
];

export enum GenAiModels {
  GEMINI_1_5_FLASH_001 = 'gemini-1.5-flash-001',
}

export const NetworkingConfiguration: {
  parent: string;
  keysToSelect: string[];
} = {
  parent: 'networking',
  keysToSelect: ['aws-vpc', 'aws-eip', 'aws-nat-gateway', 'aws-security-group', 'aws-subnet'],
};
